(function () {
  document.querySelectorAll('.acc-boncharge-lp-01-sticky-bar').forEach(function (root) {
    var bar = root.querySelector('.acc-boncharge-lp-01-sticky-bar__bar');
    if (!bar) return;

    var cta = root.querySelector('.acc-boncharge-lp-01-sticky-bar__btn');
    var priceEl = root.querySelector('.acc-boncharge-lp-01-sticky-bar__price');

    function syncPrice() {
      var offer = document.getElementById('acc-boncharge-lp-01-offer');
      if (!offer || !priceEl) return;
      var price = offer.getAttribute('data-price');
      if (price) priceEl.textContent = price;
    }

    function scrollToOffer(e) {
      var offer = document.getElementById('acc-boncharge-lp-01-offer');
      if (!offer) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = offer.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    }

    if (cta) cta.addEventListener('click', scrollToOffer);

    syncPrice();
    // The offer price is rewritten once the automatic discount resolves.
    document.addEventListener('acc-boncharge-lp-01:price-change', syncPrice);

    var trigger = document.querySelector('[data-acc-boncharge-lp-01-sticky-trigger]');
    var hider = document.querySelector('[data-acc-boncharge-lp-01-sticky-hide]');

    var pastTrigger = !trigger;
    var hiderVisible = false;

    function update() {
      bar.classList.toggle('is-visible', pastTrigger && !hiderVisible);
    }

    if ('IntersectionObserver' in window) {
      if (trigger) {
        new IntersectionObserver(function (entries) {
          var en = entries[0];
          pastTrigger = en.isIntersecting || en.boundingClientRect.top < 0;
          update();
        }, { threshold: 0 }).observe(trigger);
      }
      if (hider) {
        new IntersectionObserver(function (entries) {
          hiderVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0 }).observe(hider);
      }
    } else {
      pastTrigger = true;
    }

    update();
  });
})();
